import {Directive, inject} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {FieldValidationMessage} from "../field/field-validation-message";
import {ConfigurationModel} from '../../configuration/configuration.model';

@Directive({
    selector: "[woa-sms-phone-number]",
    providers: [{provide: NG_VALIDATORS, useExisting: SmsPhoneNumberDirective, multi: true}]
})
export class SmsPhoneNumberDirective implements Validator {
    private configurationModel: ConfigurationModel = inject(ConfigurationModel);

    validate(control: AbstractControl): ValidationErrors | null {
        return control.value && !this.configurationModel.isValidMobileNumberForSms()(control.value)
            ? {smsPhoneNumber: new FieldValidationMessage("smsPhoneNumber", "woa.validation.common.smsPhoneNumber")}
            : null;
    }
}
